import * as angular from 'angular';
import { ComponentDefinition } from '../../models';

class DataBackupRestoreController implements angular.IComponentController {
    isLoading: boolean;
    static $inject = [];

}

export const wtDataBackupRestore: ComponentDefinition = {
    componentId: 'wtDataBackupRestore',
    controller: DataBackupRestoreController,
    controllerAs: 'vm',
    template: require('./dataBackupRestore.component.html'),
    bindings: {

    }
};